import {CacheableDataObject} from "./CacheableDataObject";

class State extends CacheableDataObject
{

}
State.cache = {};
State.retrieve = function(data){
	if(State.cache[data.id])
	{
		return State.cache[data.id].update(data);
	}
	else
	{
		let state = new State(data);
		if(data.id)
		{
			State.cache[data.id] = state;
		}
		return state;
	}
};

export {State};